<template>
  <div class="vs-con-loading__container">
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mb-3">
          <div class="vx-col w-full">
            <label class="vs-input--label" v-text="$t('date')" />
            <date-picker v-model="formData.date" :model="formData.date" :placeholder="$t('date')" class="mb-3"></date-picker>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { EventBus } from '@/../eventbus.js'
import DatePicker from '@/components/form-inputs/DatePicker'
import AutoCallSystemPublic from '@/models/AutoCallSystemPublic'

export default {
  name: 'Shared.AutoCallSystemPublic.DeleteData',
  components: {
    DatePicker
  },
  data () {
    return {
      formData: {
        date: ''
      },
      companyId: this.$store.getters.userInfo.company.id,
      userId: this.$store.getters.userInfo.id
    }
  },
  mounted () {
    EventBus.$on('initResetFormData', this.initResetFormData)
    EventBus.$on('initDeleteAutoCallSystemPublicData', this.deleteData)
  },
  methods: {
    async initResetFormData () {
      this.formData = {
        date: null
      }
    },
    async deleteData () {
      try {
        const response = await AutoCallSystemPublic.deleteAutoCallSystemPublicData({date: this.formData.date})
        this.initResetFormData()
        this.$swalHelper.success({
          title: response.data,
          confirmButton: this.$t('confirm')
        }).then((() => {
          this.$emit('deleteSuccess')
        }))
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
    }
  }
}
</script>

<style lang="scss">
#deleteButton {
  .con-vs-loading {
    position: absolute !important;
  }
}
</style>
